import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { IconName, IconWrapper, SvgIcon } from '../../../../../components/Icon';
import { theme } from '../../../../../styles/theme';
import { StyledNavItem } from '../../../../../components/SecondaryNav/SecondaryNavUI';

interface IProps {
  href: string;
  iconName?: IconName;
  title: string;
  children?: ReactNode;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  isFocused?: boolean;
}

const Container = styled(StyledNavItem)<{
  $isFocused?: boolean;
}>`
  ${({ $isFocused }) =>
    $isFocused &&
    css`
      color: ${theme.colors.mainBlue};
    `}
`;
const Title = styled.div`
  flex: 1;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
`;

const DashboardTemplateLink = ({
  href,
  iconName,
  title,
  children,
  onMouseEnter,
  onMouseLeave,
  isFocused,
}: IProps) => {
  return (
    <Container
      as={NavLink}
      to={href}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      $isFocused={isFocused}
      $isInteractive={true}
      style={{
        paddingLeft: iconName ? 8 : 32,
      }}
    >
      {iconName && (
        <IconWrapper size={16}>
          <SvgIcon
            name={iconName}
            width={14}
            height={14}
            customFill="currentColor"
          />
        </IconWrapper>
      )}
      <Title>{title}</Title>
      {children}
    </Container>
  );
};

export default DashboardTemplateLink;
